export const providerNoteAction = {
  onChangeProviderNotes: (state, action) => {
    const { note, notesTouched, isOriginal = false } = action.payload;

    state.providerNotes = note;
    if (isOriginal) {
      state.originalProviderNotes = note;
    }
    state.providerNotesTouched = notesTouched;
  },

  setProviderNotesTouched: (state, action) => {
    state.providerNotesTouched = action.payload;
  },

  resetProviderNotes: (state) => {
    state.providerNotes = "";
    state.originalProviderNotes = "";
    state.providerNotesTouched = false;
  },
};
